const emptyCellCharacter = "—";
export {
  emptyCellCharacter
};
//# sourceMappingURL=types.js.map
